export default __webpack_public_path__ + "static/media/CNo.75-7.b6038adf.jpg";